import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MultiSelect from '@kenshooui/react-multi-select';
import "@kenshooui/react-multi-select/dist/style.css";
import ResalesRequestService from 'services/resales-request';

const ProviderResales = ({listCompanySelected,setListCompanySelect,documentsRemove,setDocumentsRemove,edit}) => {
  const { t } = useTranslation();
  const [listCompany, setListCompany] = useState([]);

  useEffect(()=>{
    ResalesRequestService.getCompaniesMasterAgent({ params: { masteragent: 1 } })
      .then(res => {
        setListCompany(res.data.map(a => {
          if (a.id == 79327) console.log(a)          
          const formatDocumentCompany = document => (
            document.replace( /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
          );
          return {
            id: a.id,
            label: `${a.name} - ${formatDocumentCompany(a.document)}`
          };
        }))
      })
    // ResalesRequestService.getAll({params:{
    //   company_type_id: 2, 
    //   masteragent: 1
    // }}).then(data=>{
    //   setListCompany(data.data.data.map(a=>{
    //     const formatDocumentCompany = document => (
    //       document.replace( /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    //     );
    //     return {
    //       id: a.id,
    //       label: `${a.name} - ${formatDocumentCompany(a.document)}`
    //     };
    //   }))
    // });
  },[])
  return (
  <>
    <Row className="mb-3">
      <Col md="12">
        <h6 className="title-dashboard">Revenda</h6>
      </Col>
      <Col md="12">
        <hr className="line"></hr>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <MultiSelect
          messages={{
            searchPlaceholder: "Procurar...",
            noItemsMessage: "Sem Itens...",
            noneSelectedMessage: "Nada Selecionado",
            selectedMessage: "Selecionado(s)",
            selectAllMessage: "Selecionar Todos",
            clearAllMessage: "Limpar Tudo",
            disabledItemsTooltip: "Você só pode selecionar 1 arquivo"
          }}
          items={listCompany}
          selectedItems={listCompanySelected}
          onChange={async (selected) => {
            setListCompanySelect(selected)
          }}
        />
      </Col>
    </Row>
  </>
  );
}


export default ProviderResales;